import { memo } from 'react';
import css from './SizedIcon.module.scss';
import classNames from 'classnames';
import GenericIcon from '../GenericIcon/GenericIcon';
import { SizedIconProps } from './SizedIcon.types';

/**
 * The `SizedIcon` control that is responsible to styling the size
 * of the icon when it renders.
 *
 * @param title - {@link SizedIconProps.title title} description.
 * @param iconType - {@link SizedIconProps.iconType iconType} description.
 * @param iconSize - {@link SizedIconProps.iconSize iconSize} description. (default: `'medium'`)
 * @param ariaHidden - {@link SizedIconProps.ariaHidden ariaHidden} description.
 */
const SizedIcon = memo(({
    title,
    iconType,
    iconSize = 'medium',
    ariaHidden,
}: SizedIconProps) => (
    <div
        role={'presentation'}
        className={classNames(css.icon, css[iconSize])}
        aria-hidden={ariaHidden}
    >
        <GenericIcon iconType={iconType} title={title} />
    </div>
));

export default SizedIcon;
